import {Handle, Position} from "@xyflow/react";
import {memo} from "react";

export default memo((props: { data: any, isConnectable: boolean }) => {
    return (
        <>
            <Handle
                id="ht"
                type="target"
                position={Position.Left}
                isConnectable={props.isConnectable}
            />
            <Handle
                id="vt"
                type="target"
                position={Position.Top}
                isConnectable={props.isConnectable}
            />
            <div>
                Act {props.data.act} - {props.data.chapter} - Scene {props.data.scene} - Shot {props.data.shot}
            </div>
            <div>{props.data.label}</div>
            <Handle
                id="hs"
                type="source"
                position={Position.Right}
                isConnectable={props.isConnectable}
            />
            <Handle
                id="vs"
                type="source"
                position={Position.Bottom}
                isConnectable={props.isConnectable}
            />
        </>
    );
});
